// Schema: SurveySubmission (verified against SCHEMA_REFERENCE.json).
export const SUBMIT_SURVEY_MUTATION = `
  mutation SubmitSurvey($filter: String!, $input: SurveySubmissionUpdateInput!) {
    updateSurveySubmission(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
